/* eslint-disable */
/* This file is automatically generated. Run "bundle exec rake export_permissions" to regenerate it. */
export const VIEW_ARCHITECTURES = 'view_architectures';
export const CREATE_ARCHITECTURES = 'create_architectures';
export const EDIT_ARCHITECTURES = 'edit_architectures';
export const DESTROY_ARCHITECTURES = 'destroy_architectures';
export const VIEW_AUDIT_LOGS = 'view_audit_logs';
export const VIEW_AUTHENTICATORS = 'view_authenticators';
export const CREATE_AUTHENTICATORS = 'create_authenticators';
export const EDIT_AUTHENTICATORS = 'edit_authenticators';
export const DESTROY_AUTHENTICATORS = 'destroy_authenticators';
export const CREATE_BOOKMARKS = 'create_bookmarks';
export const EDIT_BOOKMARKS = 'edit_bookmarks';
export const DESTROY_BOOKMARKS = 'destroy_bookmarks';
export const VIEW_COMPUTE_PROFILES = 'view_compute_profiles';
export const CREATE_COMPUTE_PROFILES = 'create_compute_profiles';
export const EDIT_COMPUTE_PROFILES = 'edit_compute_profiles';
export const DESTROY_COMPUTE_PROFILES = 'destroy_compute_profiles';
export const VIEW_COMPUTE_RESOURCES = 'view_compute_resources';
export const CREATE_COMPUTE_RESOURCES = 'create_compute_resources';
export const EDIT_COMPUTE_RESOURCES = 'edit_compute_resources';
export const DESTROY_COMPUTE_RESOURCES = 'destroy_compute_resources';
export const POWER_VM_COMPUTE_RESOURCES = 'power_vm_compute_resources';
export const DESTROY_VM_COMPUTE_RESOURCES = 'destroy_vm_compute_resources';
export const VIEW_COMPUTE_RESOURCES_VMS = 'view_compute_resources_vms';
export const CREATE_COMPUTE_RESOURCES_VMS = 'create_compute_resources_vms';
export const EDIT_COMPUTE_RESOURCES_VMS = 'edit_compute_resources_vms';
export const DESTROY_COMPUTE_RESOURCES_VMS = 'destroy_compute_resources_vms';
export const POWER_COMPUTE_RESOURCES_VMS = 'power_compute_resources_vms';
export const CONSOLE_COMPUTE_RESOURCES_VMS = 'console_compute_resources_vms';
export const VIEW_CONFIG_REPORTS = 'view_config_reports';
export const DESTROY_CONFIG_REPORTS = 'destroy_config_reports';
export const UPLOAD_CONFIG_REPORTS = 'upload_config_reports';
export const ACCESS_DASHBOARD = 'access_dashboard';
export const VIEW_DOMAINS = 'view_domains';
export const CREATE_DOMAINS = 'create_domains';
export const EDIT_DOMAINS = 'edit_domains';
export const DESTROY_DOMAINS = 'destroy_domains';
export const VIEW_EXTERNAL_USERGROUPS = 'view_external_usergroups';
export const CREATE_EXTERNAL_USERGROUPS = 'create_external_usergroups';
export const EDIT_EXTERNAL_USERGROUPS = 'edit_external_usergroups';
export const DESTROY_EXTERNAL_USERGROUPS = 'destroy_external_usergroups';
export const VIEW_FACTS = 'view_facts';
export const UPLOAD_FACTS = 'upload_facts';
export const VIEW_FILTERS = 'view_filters';
export const CREATE_FILTERS = 'create_filters';
export const EDIT_FILTERS = 'edit_filters';
export const DESTROY_FILTERS = 'destroy_filters';
export const VIEW_HOSTGROUPS = 'view_hostgroups';
export const CREATE_HOSTGROUPS = 'create_hostgroups';
export const EDIT_HOSTGROUPS = 'edit_hostgroups';
export const DESTROY_HOSTGROUPS = 'destroy_hostgroups';
export const VIEW_HOSTS = 'view_hosts';
export const CREATE_HOSTS = 'create_hosts';
export const EDIT_HOSTS = 'edit_hosts';
export const DESTROY_HOSTS = 'destroy_hosts';
export const BUILD_HOSTS = 'build_hosts';
export const POWER_HOSTS = 'power_hosts';
export const CONSOLE_HOSTS = 'console_hosts';
export const IPMI_BOOT_HOSTS = 'ipmi_boot_hosts';
export const FORGET_STATUS_HOSTS = 'forget_status_hosts';
export const VIEW_HTTP_PROXIES = 'view_http_proxies';
export const CREATE_HTTP_PROXIES = 'create_http_proxies';
export const EDIT_HTTP_PROXIES = 'edit_http_proxies';
export const DESTROY_HTTP_PROXIES = 'destroy_http_proxies';
export const VIEW_IMAGES = 'view_images';
export const CREATE_IMAGES = 'create_images';
export const EDIT_IMAGES = 'edit_images';
export const DESTROY_IMAGES = 'destroy_images';
export const VIEW_KEYPAIRS = 'view_keypairs';
export const DESTROY_KEYPAIRS = 'destroy_keypairs';
export const VIEW_LOCATIONS = 'view_locations';
export const CREATE_LOCATIONS = 'create_locations';
export const EDIT_LOCATIONS = 'edit_locations';
export const DESTROY_LOCATIONS = 'destroy_locations';
export const ASSIGN_LOCATIONS = 'assign_locations';
export const VIEW_LOOKUP_VALUES = 'view_lookup_values';
export const CREATE_LOOKUP_VALUES = 'create_lookup_values';
export const EDIT_LOOKUP_VALUES = 'edit_lookup_values';
export const DESTROY_LOOKUP_VALUES = 'destroy_lookup_values';
export const VIEW_MAIL_NOTIFICATIONS = 'view_mail_notifications';
export const EDIT_USER_MAIL_NOTIFICATIONS = 'edit_user_mail_notifications';
export const VIEW_MEDIA = 'view_media';
export const CREATE_MEDIA = 'create_media';
export const EDIT_MEDIA = 'edit_media';
export const DESTROY_MEDIA = 'destroy_media';
export const VIEW_MODELS = 'view_models';
export const CREATE_MODELS = 'create_models';
export const EDIT_MODELS = 'edit_models';
export const DESTROY_MODELS = 'destroy_models';
export const VIEW_OPERATINGSYSTEMS = 'view_operatingsystems';
export const CREATE_OPERATINGSYSTEMS = 'create_operatingsystems';
export const EDIT_OPERATINGSYSTEMS = 'edit_operatingsystems';
export const DESTROY_OPERATINGSYSTEMS = 'destroy_operatingsystems';
export const VIEW_ORGANIZATIONS = 'view_organizations';
export const CREATE_ORGANIZATIONS = 'create_organizations';
export const EDIT_ORGANIZATIONS = 'edit_organizations';
export const DESTROY_ORGANIZATIONS = 'destroy_organizations';
export const ASSIGN_ORGANIZATIONS = 'assign_organizations';
export const VIEW_PARAMS = 'view_params';
export const CREATE_PARAMS = 'create_params';
export const EDIT_PARAMS = 'edit_params';
export const DESTROY_PARAMS = 'destroy_params';
export const VIEW_PERSONAL_ACCESS_TOKENS = 'view_personal_access_tokens';
export const CREATE_PERSONAL_ACCESS_TOKENS = 'create_personal_access_tokens';
export const REVOKE_PERSONAL_ACCESS_TOKENS = 'revoke_personal_access_tokens';
export const VIEW_PTABLES = 'view_ptables';
export const CREATE_PTABLES = 'create_ptables';
export const EDIT_PTABLES = 'edit_ptables';
export const DESTROY_PTABLES = 'destroy_ptables';
export const LOCK_PTABLES = 'lock_ptables';
export const VIEW_PROVISIONING_TEMPLATES = 'view_provisioning_templates';
export const CREATE_PROVISIONING_TEMPLATES = 'create_provisioning_templates';
export const EDIT_PROVISIONING_TEMPLATES = 'edit_provisioning_templates';
export const DESTROY_PROVISIONING_TEMPLATES = 'destroy_provisioning_templates';
export const DEPLOY_PROVISIONING_TEMPLATES = 'deploy_provisioning_templates';
export const LOCK_PROVISIONING_TEMPLATES = 'lock_provisioning_templates';
export const VIEW_REPORT_TEMPLATES = 'view_report_templates';
export const CREATE_REPORT_TEMPLATES = 'create_report_templates';
export const EDIT_REPORT_TEMPLATES = 'edit_report_templates';
export const DESTROY_REPORT_TEMPLATES = 'destroy_report_templates';
export const LOCK_REPORT_TEMPLATES = 'lock_report_templates';
export const GENERATE_REPORT_TEMPLATES = 'generate_report_templates';
export const VIEW_PLUGINS = 'view_plugins';
export const VIEW_REALMS = 'view_realms';
export const CREATE_REALMS = 'create_realms';
export const EDIT_REALMS = 'edit_realms';
export const DESTROY_REALMS = 'destroy_realms';
export const VIEW_ROLES = 'view_roles';
export const CREATE_ROLES = 'create_roles';
export const EDIT_ROLES = 'edit_roles';
export const DESTROY_ROLES = 'destroy_roles';
export const ESCALATE_ROLES = 'escalate_roles';
export const VIEW_SETTINGS = 'view_settings';
export const EDIT_SETTINGS = 'edit_settings';
export const VIEW_SMART_PROXIES = 'view_smart_proxies';
export const CREATE_SMART_PROXIES = 'create_smart_proxies';
export const EDIT_SMART_PROXIES = 'edit_smart_proxies';
export const DESTROY_SMART_PROXIES = 'destroy_smart_proxies';
export const VIEW_SMART_PROXIES_AUTOSIGN = 'view_smart_proxies_autosign';
export const CREATE_SMART_PROXIES_AUTOSIGN = 'create_smart_proxies_autosign';
export const DESTROY_SMART_PROXIES_AUTOSIGN = 'destroy_smart_proxies_autosign';
export const VIEW_SMART_PROXIES_PUPPETCA = 'view_smart_proxies_puppetca';
export const EDIT_SMART_PROXIES_PUPPETCA = 'edit_smart_proxies_puppetca';
export const DESTROY_SMART_PROXIES_PUPPETCA = 'destroy_smart_proxies_puppetca';
export const VIEW_SSH_KEYS = 'view_ssh_keys';
export const CREATE_SSH_KEYS = 'create_ssh_keys';
export const DESTROY_SSH_KEYS = 'destroy_ssh_keys';
export const VIEW_SUBNETS = 'view_subnets';
export const CREATE_SUBNETS = 'create_subnets';
export const EDIT_SUBNETS = 'edit_subnets';
export const DESTROY_SUBNETS = 'destroy_subnets';
export const IMPORT_SUBNETS = 'import_subnets';
export const VIEW_USERGROUPS = 'view_usergroups';
export const CREATE_USERGROUPS = 'create_usergroups';
export const EDIT_USERGROUPS = 'edit_usergroups';
export const DESTROY_USERGROUPS = 'destroy_usergroups';
export const VIEW_USERS = 'view_users';
export const CREATE_USERS = 'create_users';
export const EDIT_USERS = 'edit_users';
export const DESTROY_USERS = 'destroy_users';
export const VIEW_STATUSES = 'view_statuses';
